import React from 'react';
import './HowItWorks.css';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Upload Your Photos',
      description: 'Select 5-10 clear selfies from different angles. Our AI analyzes facial features for best results.',
      image: '/assets/step-upload.png'
    },
    {
      number: '02',
      title: 'Choose Your Style',
      description: 'Browse through 56+ professional styles. Preview watermarked samples before purchasing.',
      image: '/assets/step-style.png'
    },
    {
      number: '03',
      title: 'Get Your Portraits',
      description: 'Receive high-resolution AI portraits ready for social media, professional use, or printing.',
      image: '/assets/step-result.png'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Simple as 1-2-3</h2>
          <p className="section-subtitle">
            Transform your selfies into professional portraits in minutes
          </p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <img src={step.image} alt={step.title} className="step-image" />
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <svg className="connector-arrow" viewBox="0 0 100 20">
                    <path d="M0,10 L90,10 M80,5 L90,10 L80,15" stroke="currentColor" strokeWidth="2" fill="none"/>
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;